import { render, staticRenderFns } from "./Consiglio.vue?vue&type=template&id=57fa581a&scoped=true&"
import script from "./Consiglio.vue?vue&type=script&lang=ts&"
export * from "./Consiglio.vue?vue&type=script&lang=ts&"
import style0 from "./Consiglio.vue?vue&type=style&index=0&id=57fa581a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa581a",
  null
  
)

export default component.exports